export const MIN_PWA_GLOBAL_SEARCH_LENGTH = 3;
export const MAX_PWA_GLOBAL_SEARCH_RESULTS = 25;
const PROJECTS_LIST_KEY = 'projectsList';

export function normalizeProjectRecords(records) {
  if (!Array.isArray(records)) {
    return [];
  }
  return records.filter((project) => project?.Project__r != null);
}

export function readCachedProjectList() {
  try {
    const cached = localStorage.getItem(PROJECTS_LIST_KEY);
    if (!cached) {
      return null;
    }
    const parsed = JSON.parse(cached);
    const normalized = normalizeProjectRecords(parsed);
    return normalized.length > 0 ? normalized : null;
  } catch {
    return null;
  }
}

export async function fetchProjectList(authFetch) {
  const response = await authFetch(
    `${process.env.REACT_APP_BACKEND_BASEURL}/api/salesforce/all-opportunities`
  );

  if (!response.ok) {
    const errorBody = await response.json().catch(() => ({}));
    throw new Error(errorBody.message || `Request failed (${response.status})`);
  }

  const data = await response.json();
  if (!Array.isArray(data.records)) {
    throw new Error('Unexpected API response format');
  }

  const projects = normalizeProjectRecords(data.records);
  localStorage.setItem(PROJECTS_LIST_KEY, JSON.stringify(projects));
  return projects;
}

export function buildProjectSearchIndex(projects) {
  return projects.map((project) => ({
    project,
    opportunityId: project.Id,
    projectName: project.Project__r?.Name || '',
    projectNo: project.Project__r?.Project_System_Wide_ID__c || '',
    opportunityNo: project.Opportunity_System_Wide_ID__c || '',
    searchName: (project.Project__r?.Name || '').toLowerCase(),
    searchProjectNo: (project.Project__r?.Project_System_Wide_ID__c || '').toLowerCase(),
    searchOpportunityNo: (project.Opportunity_System_Wide_ID__c || '').toLowerCase(),
  }));
}

export function filterProjectSearchIndex(index, query) {
  const normalizedQuery = query.trim().toLowerCase();
  if (normalizedQuery.length < MIN_PWA_GLOBAL_SEARCH_LENGTH) {
    return [];
  }

  const results = [];
  for (let i = 0; i < index.length; i += 1) {
    const item = index[i];
    if (
      item.searchName.includes(normalizedQuery)
      || item.searchProjectNo.includes(normalizedQuery)
      || item.searchOpportunityNo.includes(normalizedQuery)
    ) {
      results.push(item);
      if (results.length >= MAX_PWA_GLOBAL_SEARCH_RESULTS) {
        break;
      }
    }
  }

  return results;
}
